<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters><v-col cols="12">
      <i-card-vertical :headerTitle="menuTitle"><template v-slot:body>
        <v-row no-gutters><v-col cols="12" class="pb-1">
          <i-card-top class="d-md-flex" outlined :useBtnList="useBtnList" :customBtnList="customBtnList" @btnRetrieve="retrieve" @btnSaveAsExcel="saveExcel">
            <template v-slot:body><v-row no-gutters class="center pa-2 pb-0">
              <i-label :label="'Ship No :'" />
              <v-col cols="2"><v-select v-model="shipNo" :items="shipNoList" return-object item-value="code" item-text="codeName" outlined dense height="32" @change="shipNoChanged" /></v-col>
              <i-label :label="'POR No :'" class="pl-2" />
              <v-col cols="2"><v-select v-model="porNo" :items="porNoList" return-object item-value="code" item-text="codeName" outlined dense height="32" /></v-col>
              <v-col class="pa-1 pl-4">
                            <span class="pa-1 subText" style="background-color: #C0E0FF;">Issued</span>
                            <span class="pa-1 subText" style="background-color: #FFAACC;">Requested</span>
                            <span class="pa-1 subText" style="background-color: #FF4040;">No have Stock</span>
                            <span class="pa-1 subText" style="background-color: #FFFFFF;">Not yet Request</span>
                          </v-col>
            </v-row></template>
          </i-card-top>
        </v-col></v-row>
        <v-row no-gutters><v-col class="pt-1">
          <DxDataGrid class="listBox" 
                      id="epms90a1Grid" 
                      :ref="gridRef" 
                      :data-source="gridRows" 
                      :remote-operations="false" 
                      :hover-state-enabled="true" 
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true" 
                      :row-alternation-enabled="true" 
                      :show-borders="true"                       
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true" 
                      :column-hiding-enabled="false"                      
                      :sorting="{ mode: 'none' }" 
                      :selection="{ mode: 'none' }"
                      @cellPrepared="cellPrepared">            
            <DxScrolling mode="standard" show-scrollbar="always" />
            <DxPaging :enabled="true" :page-size="16" /><DxPager :visible="true" />            
            <DxColumn data-field="shipNo" caption="Ship No" width="6%" alignment="center" :allow-editing="false" />
            <DxColumn data-field="porNoSeq" caption="POR No" width="8%" alignment="center" :allow-editing="false" />
            <DxColumn caption="Raw Material Information" alignment="center" :allow-editing="false">
              <DxColumn data-field="matlCd" caption="Material Code" width="9%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="matlSpec" caption="Material Spec" width="15%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="poQty" caption="PO Qty" width="5%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="poDte" caption="PO Date" width="7%" alignment="center" :allow-editing="false" />
            </DxColumn>
            <DxColumn caption="Delivery Information" alignment="center" :allow-editing="false">
              <DxColumn data-field="makerDlyDt" caption="Maker Delivery Date" width="7%" alignment="center" :allow-editing="false" header-cell-template="makerDeliveryHeader" />
              <DxColumn data-field="kasWhDte" caption="KAS WH Date" width="7%" alignment="center" :allow-editing="false" header-cell-template="kasWhHeader" />
              <DxColumn data-field="makerNm" caption="Maker Name" width="12%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="shippingDte" caption="Shipping Date" width="7%" alignment="center" :allow-editing="false" header-cell-template="shippingHeader" />
              <DxColumn data-field="whDte" caption="WH Date" width="7%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="issueDte" caption="Issue Date" width="7%" alignment="center" :allow-editing="false" />
            </DxColumn>
            <DxColumn caption="Fabrication Information" alignment="center" :allow-editing="false">
              <DxColumn data-field="shipNoFab" caption="Fab Ship No" width="6%" alignment="center" :allow-editing="false" header-cell-template="fabShipHeader" />
              <DxColumn data-field="porNoFabLine" caption="Fab POR No" width="8%" alignment="center" :allow-editing="false" header-cell-template="fabPorHeader" />
              <DxColumn data-field="partNo" caption="Part No" width="7%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="partSpec" caption="Part Spec" width="12%" alignment="center" :allow-editing="false" />
              <DxColumn data-field="uses" caption="Use Length" width="5%" alignment="center" :allow-editing="false" header-cell-template="useLengthHeader" />
              <DxColumn data-field="cuttingMargin" caption="Cut Margin" width="5%" alignment="center" :allow-editing="false" header-cell-template="cutMarginHeader" />
              <DxColumn data-field="mnd" caption="MATL Need Date" width="7%" alignment="center" :allow-editing="false" header-cell-template="matlNeedHeader" />
            </DxColumn>
            <template #makerDeliveryHeader><div>Maker<br>Delivery Date</div></template>
            <template #kasWhHeader><div>KAS WH<br>Date</div></template>
            <template #shippingHeader><div>Shipping<br>Date</div></template>
            <template #fabShipHeader><div>Fab Ship<br>No</div></template>
            <template #fabPorHeader><div>Fab POR<br>No</div></template>
            <template #useLengthHeader><div>Use<br>Length</div></template>
            <template #cutMarginHeader><div>Cut<br>Margin</div></template>
            <template #matlNeedHeader><div>MATL Need<br>Date</div></template>
          </DxDataGrid>
        </v-col></v-row>
      </template></i-card-vertical>
    </v-col></v-row>
  </v-container>
</template>


<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { DxDataGrid, DxColumn, DxPaging, DxPager, DxScrolling } from 'devextreme-vue/data-grid'
import { getShipNoList, getPorNoList, epms90a1List } from '@/api/view/hip/90/epms90a1'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid } from 'devextreme/excel_exporter'

export default {
  name: 'epms90a1',
  mixins: [baseview, BaseDataGrid],
  components: { DxDataGrid, DxColumn, DxPaging, DxPager, DxScrolling },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      gridRef: 'epms90a1GridRef',
      useBtnList: ['btnRetrieve', 'btnSaveAsExcel'],
      customBtnList: [{ id: 'btnSaveAsExcel', text: 'Save Excel', icon: 'excel' }],
      shipNo: null, shipNoList: [], porNo: null, porNoList: [], gridRows: []
    }
  },
  computed: { gridInstance() { return this.GetDataGrid(this.gridRef) } },
  mounted() { this.loadShipNos() },
  methods: {
    async loadShipNos() {
      const res = await getShipNoList({})
      this.shipNoList = [{ code: '', codeName: 'Select' }, ...(res.list || []).map(row => ({ code: row.shipNo, codeName: row.shipNo }))]
      this.shipNo = this.shipNoList[0]
      this.porNoList = [{ code: '', codeName: 'All' }]
      this.porNo = this.porNoList[0]
    },
    async shipNoChanged() {
      this.gridRows = []
      this.porNoList = [{ code: '', codeName: 'All' }]
      this.porNo = this.porNoList[0]
      if (!this.shipNo || !this.shipNo.code) return
      const res = await getPorNoList({ shipNo: this.shipNo.code })
      this.porNoList = [{ code: '', codeName: 'All' }, ...(res.list || []).map(row => ({ code: row.porNo, codeName: row.porNo }))]
      this.porNo = this.porNoList[0]
    },
    async retrieve() {
      if (!this.shipNo || !this.shipNo.code) {
        this.gridRows = []
        this.vToastify('Select Ship No.', 'warn')
        return
      }
      this.openLoading('searching')
      try {
        const res = await epms90a1List({ shipNo: this.shipNo.code, porNo: this.porNo && this.porNo.code ? this.porNo.code : '' })
        this.gridRows = (res.list || []).map((row, id) => ({
          ...row, id,
          porNoSeq: `${row.porNo || ''}-${row.porSeq || ''}`,
          porNoFabLine: `${row.porNoFab || ''}-${row.lineNoFab || ''}`
        }))
      } finally { this.endLoading() }
    },
    async saveExcel() {
      if (!this.gridRows.length) {
        this.vToastify('No data to export.', 'warn')
        return
      }
      this.openLoading()
      try {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('Raw Material')
        await exportDataGrid({
          component: this.gridInstance,
          worksheet,
          selectedRowsOnly: false
        })
        const buffer = await workbook.xlsx.writeBuffer()
        saveAs(new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }), 'Raw Material.xlsx')
      } catch (error) {
        this.vToastify('Failed to export Excel.', 'error')
      } finally {
        this.endLoading()
      }
    },
    cellPrepared(e) {
      if (e.rowType !== 'data') return
      e.cellElement.style.border = '1px solid #808080'
      if (e.data.issYn === 'Y') e.cellElement.style.backgroundColor = '#C0E0FF'
      else if (e.data.resYn === 'Y') e.cellElement.style.backgroundColor = '#FFAACC'
      else if (e.data.whYn === 'N') e.cellElement.style.backgroundColor = '#FF4040'
    }
  }
}
</script>
